export default __webpack_public_path__ + "static/media/teamElement.e36c089e.webp";